export enum TicketPlannedStatus {
	None = 0,
    Planned = 1,
    PlannedToday = 2,
    UntilToday = 3
}

export function getTicketStatusName(status: TicketPlannedStatus): any {
	if (status == TicketPlannedStatus.Planned) {
		return ["planned", "gepland"];
	}
	if (status == TicketPlannedStatus.PlannedToday) {
		return ["today", "vandaag"];
	}
	if (status == TicketPlannedStatus.UntilToday) {
		return ["until-today", "tot en met vandaag"];
	}
	return ["invalid", "invalid"];
}